import React from "react";
import workerAnniversary from "../../../../assets/dashboard/worker.jpg";
import { baseURLImage, formatDateToAustralian, getNameProfile, capitalizeFirstLetter } from "Utils/utils";

const AnniversaryCard = ({ item }) => {
  const backgroundImageStyle = {
    backgroundImage: `url(${workerAnniversary})`,
    backgroundSize: "cover", // Adjust as needed
    backgroundRepeat: "no-repeat", // Adjust as needed
  };

  //check date if date is today
  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() && date.getMonth() === today.getMonth()
    );
  };

  // Usage example:
  const joiningDate = new Date(item?.joining_date);
  const isBirthdayToday = isToday(joiningDate);

  const handleImageError = (e, fname, lname) => {
    return (e.target.src = getNameProfile(fname, lname));
  };

  return (
    <div className="bg-gradient-to-br from-blue-50 via-cyan-50 to-blue-100 border border-blue-200 rounded-lg p-3 sm:p-4 hover:shadow-md transition-all duration-200 group">
      <div className="flex items-center gap-2 sm:gap-3">
        <div className="relative h-10 w-10 sm:h-12 sm:w-12 flex-shrink-0">
          <img
            onError={(e) => handleImageError(e, item?.name, item?.name)}
            className="object-cover h-10 w-10 sm:h-12 sm:w-12 rounded-full ring-2 ring-blue-300 group-hover:ring-blue-400 transition-all"
            src={
              item?.photo
                ? baseURLImage(item?.photo)
                : getNameProfile(item.name, item?.name || " ")
            }
            alt=""
          />
          {isBirthdayToday && (
            <div className="absolute -top-1 -right-1 h-3 w-3 sm:h-4 sm:w-4 bg-blue-500 rounded-full border-2 border-white animate-pulse"></div>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-xs sm:text-sm text-gray-900 truncate">
            {capitalizeFirstLetter(item?.name || '')}
          </div>
          <div className={`text-[10px] sm:text-xs font-medium mt-1 ${isBirthdayToday ? 'text-blue-600' : 'text-gray-600'}`}>
            {isBirthdayToday ? (
              <span className="flex items-center gap-1">
                <span className="inline-block w-1.5 h-1.5 sm:w-2 sm:h-2 bg-blue-500 rounded-full animate-pulse"></span>
                <span className="truncate">Anniversary Today! 🎊</span>
              </span>
            ) : (
              <span className="truncate">Anniversary on {formatDateToAustralian(item?.joining_date)}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnniversaryCard;
